import React from 'react';
import PropTypes from 'prop-types';
import '../css/Menu.css';
import formater from './formater';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
import SectionLinks from '../SectionLinks';

/**
 * Menu component
 */
class Menu extends React.Component {
  static displayName = 'Menu';
  static propTypes = {
    className: PropTypes.string,
    store: PropTypes.object.isRequired,
    unselectTag: PropTypes.func.isRequired,
    closeMenu: PropTypes.func.isRequired,
    toggleTag: PropTypes.func.isRequired,
    tag: PropTypes.string,
    isMenuOpen: PropTypes.bool.isRequired,
    Projects: PropTypes.array.isRequired,
    section: PropTypes.string,
    history: PropTypes.object.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = 'Menu';
    this.state = {
      primary: 'projets',
      secondary: null,
    };
    this.years = this.getYears();
    this.switchPrimary = this.switchPrimary.bind(this);
    this.switchSecondary = this.switchSecondary.bind(this);
    this.navLinks = this.navLinks.bind(this);
  }

  /**
   * @override
   */
  componentDidMount() {

    if( this.props.tag=='Actualités'){
      let secondary = 'Index';
      if(this.props.currentPage && this.props.currentPage=='ActuYear'){
        console.log('setyera', parseInt(this.props.match.params.year))
        secondary = parseInt(this.props.match.params.year)
      }
      this.setState({
        primary: 'actualites',
        secondary:  secondary
      });
    }
    if(this.props.match.path === "/projects/"){
      this.setState({
        secondary: 'Index'
      })
    }
   
    if (_.isNil(this.props.section)) return;

    if (
      this.state.secondary === this.props.section &&
      this.state.primary === 'bureau'
    )
      return;
    this.setState({
      secondary: this.props.section,
      primary: 'bureau',
    });

    
  }

  getYears(){
    const years = new Set();
    this.props.store.Projects.map((project)=>{
      if(project.is_actualite) years.add(...project.year);
    })
    return Array.from(years).sort((a,b)=>a<b);
  }

  /**
   * Get navigation links.
   */
  navLinks() {
    const tags = this.props.store.Router
      .filter((p) => p.type === 'TagPage')
      .map((t) => t.title);
    
    return {
      projets: ['Index', ...tags],
      bureau: ['Contact', 'Profil', 'Equipe','Jobs', 'Publications', 'Social media'],
      actualites: ['Index', ...this.years],
    };
  }

  /**
   * Show primary menu
   * @param {string} primary
   * @param {string} secondary
   */
  switchPrimary(primary, secondary) {

    this.setState({primary, secondary});
  }
  /**
   * show a secondary menu.
   * @param {string} secondary
   */
  switchSecondary(secondary) {

    if (secondary) this.setState({secondary});

    if(this.state.primary=="actualites"){
      if(secondary=='Index'){
        this.props.history.push('/');
      }else{
        this.props.history.push('/years/'+secondary);
      }
    }else{
      this.props.history.push(SectionLinks[secondary]);
    }
  }

  /**
   * Show project index
   */
  switchIndexProjet(){
    this.setState({
      primary: 'projets',
      secondary: 'Index'
    })
    this.props.history.push('/projects');
  }

  /**
   * @override
   */
  render() {

    return (
      <div>
        <div
          className={`${this.className} ${this.props.className || ''} ${this
            .props.isMenuOpen
            ? 'open'
            : 'close'}`}
        >
          <div
            className={`${this.className}__close`}
            onClick={this.props.closeMenu}
          >
            <svg style={{width: '24px', height: '24px'}} viewBox="0 0 24 24">
              <path
                fill="#000000"
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
              />
            </svg>
          </div>
          <a className={`${this.className}__logo`} href="/">
            <div>
              Aeby<br />&<br />Associés
            </div>
            <div>
              Perneger<br />
              <br />SA
            </div>
          </a>
          <div className={`${this.className}__navlinks`}>
            <div className={`${this.className}__nav-primary`}>
            <div
                className={`${this.className}__navlink ${this.state.primary ===
                'actualites'
                  ? 'active'
                  : ''}`}
                onClick={() => {
                  this.switchPrimary('actualites', 'Index');
                  this.props.unselectTag();
                  this.props.toggleTag('Actualités');
                }}
              >
                Actualités
              </div>
              <div
                className={`${this.className}__navlink ${this.state.primary ===
                'projets'
                  ? 'active'
                  : ''}`}
                onClick={() => this.switchIndexProjet()}
              >
                Projets
              </div>
              <div
                className={`${this.className}__navlink ${this.state.primary ===
                'bureau'
                  ? 'active'
                  : ''}`}
                onClick={() => this.switchPrimary('bureau', 'contact')}
              >
                Bureau
              </div>
            </div>
            <div className={`${this.className}__nav-secondary`}>
              {this.state.primary &&
                this.state.primary === 'projets' &&
                this.navLinks()[this.state.primary].map((navlink, index) => {

                  if (navlink === 'Actualités') return null;
                  if (navlink === 'Index' || navlink === '')
                    return '';
                  const tag = navlink.toLowerCase();
                  const currentTag = this.props.tag
                    ? this.props.tag.toLowerCase()
                    : null;
                  return (
                    <div
                      key={index}
                      onClick={() => this.props.toggleTag(tag)}
                      className={
                        `${this.className}__navlink ` +
                        `${currentTag === tag ? 'active' : ''}`
                      }
                    >
                      {navlink}
                    </div>
                  );
                })}
              {this.state.primary &&
                this.state.primary === 'bureau' &&
                this.navLinks()[this.state.primary].map((navlink, index) =>
                <div
                key={'navprimary-' + index}
                onClick={() => this.switchSecondary(navlink)}
                className={`${this.className}__navlink ${this.state
                  .secondary === navlink
                  ? 'active'
                  : ''} ${navlink === '' ? 'space' : ''}`}
                  >
                    {navlink || '___'}
                  </div>
                )}
      
              {this.state.primary &&
                this.state.primary === 'actualites' &&
                this.navLinks()[this.state.primary].map((navlink, index) => {
                  if(navlink==='Index') return '';
                  return(
                  <div
                    key={'navprimary-' + index}
                    onClick={() => this.switchSecondary(navlink)}
                    className={`${this.className}__navlink ${this.state
                      .secondary === navlink
                      ? 'active'
                      : ''} ${navlink === '' ? 'space' : ''}`}
                  >
                    {navlink || '___'}
                  </div>
                  )}
                )}
            </div>
          </div>
          {false && this.state.secondary && this.state.secondary === 'Index' && this.state.primary == 'projets'
            ? <div className={`${this.className}__content index`}>
              {this.props.Projects.map((project, index) => {
                return (
                  <div className={`${this.className}__index`} key={index+'index'}>
                    <a className="title" href={project.link}>
                      {project.title}
                    </a>
                    <div className="description">
                      {`${project.year.join(
                          '–'
                        )} / ${project.master} / ${project.type}`}
                    </div>
                  </div>
                );
              })}
            </div>
            : <div className={`${this.className}__content`}>
              {formater(this.state.secondary, this.props.store, this.props.history)}
            </div>}
        </div>
        <div
          className={`${this.className}__overlay`}
          onClick={this.props.closeMenu}
        />
      </div>
    );
  }
}

export default withRouter(Menu);
